import { useEffect, useRef, useState } from "react";

import { Input } from "antd";
import classnames from "classnames";
import styled from "styled-components";

interface SearchBarProps {
  readonly filterText: string;
  readonly onFilterChange: (value: string) => void;
  readonly active?: boolean;
  readonly isVisible?: boolean;
}

const SearchBar = ({
  filterText,
  onFilterChange,
  active = false,
  isVisible = false
}: SearchBarProps) => {
  const inputRef = useRef(null);
  const [value, setValue] = useState(filterText);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    onFilterChange(newValue);
  };

  useEffect(() => {
    if (value !== filterText) {
      setValue(filterText);
    }
  }, [filterText]);

  useEffect(() => {
    if (inputRef.current && active && isVisible) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 100);
    }
  }, [active, isVisible]);

  const rootClassName = classnames({
    "keyboard-focused": active
  });

  return (
    <SearchSection>
      <SearchTitle>Select Field</SearchTitle>
      <Input
        ref={inputRef}
        allowClear
        value={value}
        onChange={handleSearch}
        placeholder="Search field"
        className={`${rootClassName}`}
        style={{ width: "273px", marginLeft: "auto" }}
      />
    </SearchSection>
  );
};

export default SearchBar;

const SearchSection = styled.div`
  display: grid;
  grid-template-columns: calc(var(--search-width) - var(--space-4)) 1fr;
  align-items: center;
  gap: var(--space-4);
  background-color: var(--color-white);
  padding: var(--space-2) var(--space-4);
`;
const SearchTitle = styled.span`
  width: calc(var(--search-width) - var(--space-2));
  font-weight: var(--fontWeightBold);
`;
